import React from 'react'
import { Header, Container, TextLink } from 'components'
import { config } from 'config'

const { SUPPORT_MAIL } = config!

export class ErrorBoundary extends React.Component<any, { hasError: boolean }> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="h-full w-full flex flex-col">
          <Header isErrorBoundary />
          <Container>
            <h1 className="mt-20 text-3xl text-center">Sorry, something does not look right.</h1>
            <div className="flex text-center items-center justify-center text-2xl -max-w-xl mt-16 pb-28">
              <p className="font-light">
                For any queries regarding access to Morrisons Supplier Data Hub, please email{' '}
                <TextLink isEmail hrefLink={SUPPORT_MAIL} displayText={SUPPORT_MAIL} /> <br />
                detailing your query and we will get back to you as soon as possible.
              </p>
            </div>
          </Container>
        </div>
      )
    }

    return this.props.children
  }
}
